import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

/** PATCH to update individual affiliation property values */
const useUpdateAffiliationMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const updateAffiliation = async (id, property, value) => {
    const url = encodeURI(`${env.apiUrl}/affiliations/${id}`)
    const response = await securedFetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ [property]: value })
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ id, property, value }) =>
      updateAffiliation(id, property, value),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error updating group'),
    onSuccess: () => {
      setMessage('Updated group')
      queryClient.invalidateQueries('affiliations')
      queryClient.invalidateQueries('admin-affiliations')
    },
    onSettled: progressEnd
  })
}

export { useUpdateAffiliationMutation }
